import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';

interface Props {
  id: string;
  dataSource?: any[];
  title?: string;
  name?: any,
  data?: any,
  label?: any,
  barWidth?: number,
  height?: string,
  legend?: boolean
}


export const AdvancedColumnChart: React.FC<Props> = (props: Props) => {
  useEffect(() => {
    let chart: Highcharts.Chart | undefined;
   
    
    const seriesData = props?.dataSource?.map((range: any) => ({
      name: range?.name,
      color: range?.color,
      data: range?.data.map((item: any) => ({
        name: item?.name,
        y: item?.y ?? 0,
        totalPosts: item?.totalPosts ?? 0,
        isAverage: item?.isAverage ?? false, // ✅ ADD THIS
      })),      
    }));

    const categories = seriesData?.[0]?.data?.map((i: any) => i.name) ?? [];

    const chartOptions: Highcharts.Options = {
      chart: {
        type: "column",
        borderRadius: 4,
        height: props.height || '260px',
      },
      title: {
        text: props.title,
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        labels: {
          style: {},
        },
        categories, // Use the extracted categories here
        crosshair: true,
        type: "category",
      },
      yAxis: {
        labels: {
          style: {},
          y: 10,
        },
        min: 0,
        gridLineWidth: 0,
        title: {
          text: "",
          style: {},
        },
      },
 
  tooltip: {
  useHTML: true,
  shared: true,
  formatter: function (this: Highcharts.TooltipFormatterContextObject) {

    if (!this.points || this.points.length === 0) {
      return "";
    }

    const point: any = this.points[0].point;
    const series = this.points[0].series;
    const value = point?.y ?? 0;

    const formattedValue = point?.isAverage
      ? Highcharts.numberFormat(value, 1)
      : Highcharts.numberFormat(value, 0);

    return `
      <span style="font-size:10px">${point.category}</span>
      <table>
        <tr>
          <td style="color:${series.color};padding:5px 10px 0 0;">
            ${series.name}:
          </td>
          <td style="padding:5px 0 0 0;">
            <b>${formattedValue}</b>
          </td>
        </tr>
        <tr>
          <td style="padding:6px 10px 0 0;">
            Total Posts:
          </td>
          <td style="padding:6px 0 0 0;">
            <b>${point.totalPosts}</b>
          </td>
        </tr>
      </table>
    `;
  }
},
      
      plotOptions: {
        column: {
          pointWidth: props.barWidth ?? 0.2,
          borderWidth: 0,
        },
      },
      legend: {
        y: 2,
        x: -4,
        enabled: props.legend
      },
      series: seriesData as any,
      exporting: {
        enabled: false,
        buttons: {
          contextButton: {
            menuItems: [
              'viewFullscreen',
              'printChart',
              //'downloadPNG',
              'downloadJPEG',
              'downloadPDF',
              //'downloadSVG',
              'downloadCSV',
              'downloadXLS',
            ]
          }
        }
      }

    };

    chart = Highcharts.chart(props.id, chartOptions);
      return () => {
      if (chart) {
        chart.destroy();
        chart = undefined;
      }
    };

  }, [props.data, props.dataSource, props.title, props.id]);

  return (
    <div id={props.id} style={{ width: "100%", height: props?.height ?? "350px" }} />
  );
};
